import axios from 'axios'

const apiInterceptor = axios.create({
  baseURL: process.env.REACT_APP_API ,
  headers: {
    'Content-Type': 'application/json',
  }
})

apiInterceptor.interceptors.request.use((config) => {
// console.log(config,'config from apiinterceptor');
  const token = localStorage.getItem('token')
  if(token){
    config.headers['Authorization'] = token
  }
  return config
})

// interceptor for global error handling.
apiInterceptor.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Axios request error:', error)
    return Promise.reject(error)
  }
)

export default apiInterceptor
